import * as React from 'react';

/**
 * Форма добавления/редактирования поста блога
 */
export const AddPostFormStub = () => {
  return <div />;
};
